import Api from 'services/api/Api';
import pages from 'services/routes/pages';
import { USER_MANAGEMENT } from 'services/routes/constants';
import { TABLE_ROWS_PER_PAGE } from 'domain/user-management/consts';
import apiUtils from 'services/apiUtils';

const UserManagementApiFactory = () => {
  const url = pages[USER_MANAGEMENT].endpoint;

  return {
    fetchAll: async (query) =>
      Api.get(apiUtils.buildUrlWithQueryStrings(url, query)),
    create: async (data) => Api.post(url, data),
    update: async ({ targetId, apiItem }) =>
      Api.put(`${url}/${targetId}/`, apiItem),
    delete: async (ids) =>
      Api.delete(apiUtils.buildUrlWithQueryStrings(url, { user_ids: ids })),
  };
};

const UserManagementApi = UserManagementApiFactory();
export default UserManagementApi;
